import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.animateProgressBar()
  }

  animateProgressBar() {
    const progressBars = document.querySelectorAll('.progress-bar-fill')

    progressBars.forEach(progressBar => {
      const targetWidth = progressBar.dataset.targetWidth
      if (targetWidth) {
        setTimeout(() => {
          progressBar.style.width = targetWidth
        }, 300)
      }
    })
  }

  updateProgress() {
    const inputs = document.querySelectorAll(`[name^="daily_action[actionable_attributes]"]`)
    const totalQuestions = inputs.length
    const answeredQuestions = Array.from(inputs).filter(question => question.value.trim() !== '').length
    const progressPercentage = Math.round((answeredQuestions / totalQuestions) * 100)

    const progressBars = document.querySelectorAll('.progress-bar-fill')
    progressBars.forEach(progressBar => {
      progressBar.style.width = `${progressPercentage}%`
      progressBar.dataset.targetWidth = `${progressPercentage}%`
      progressBar.dataset.answeredQuestions = answeredQuestions
    })

    const answeredCount = document.querySelectorAll('[data-progress="answered-count"]')
    answeredCount.forEach(count => {
      count.textContent = answeredQuestions
    })

    const menuWarning = document.querySelector('#incomplete-progress-actions-indicator')
    const progressBarWarnings = document.querySelectorAll('#progress-bar-warning')

    if (menuWarning) {
      if (answeredQuestions < totalQuestions) {
        menuWarning.classList.remove('hidden')

        progressBarWarnings.forEach(warning => {
          warning.classList.remove('hidden')
        })
      } else {
        menuWarning.classList.add('hidden')

        progressBarWarnings.forEach(warning => {
          warning.classList.add('hidden')
        })
      }
    }
  }

  editAnswer(event) {
    const questionType = event.currentTarget.dataset.questionType
    const questionId = event.currentTarget.dataset.questionId

    const answer = document.querySelector(`#${questionType}-answer-${questionId}`)
    const answerInput = document.querySelector(`#${questionType}-answer-input-${questionId}`)

    event.currentTarget.classList.add('hidden')
    answer.classList.add('hide')
    answerInput.classList.add('show')
  }

  cancelEdit(event) {
    const questionType = event.currentTarget ? event.currentTarget.dataset.questionType : event.target.dataset.questionType
    const questionId = event.currentTarget ? event.currentTarget.dataset.questionId : event.target.dataset.questionId

    const answer = document.querySelector(`#${questionType}-answer-${questionId}`)
    const answerInput = document.querySelector(`#${questionType}-answer-input-${questionId}`)
    const editButton = document.querySelector(`#${questionType}-edit-button-${questionId}`)
    const textArea = answerInput.querySelector('textarea')

    answerInput.classList.remove('show')
    answer.classList.remove('hide')
    textArea.value = answer.textContent.replace(/Answer:\s*/g, '').replace(/\n/g, '')
    editButton.classList.remove('hidden')
  }

  saveAnswer(event) {
    event.target.disabled = true
    event.target.textContent = 'Saving...'

    const questionType = event.target.dataset.questionType
    const questionId = event.target.dataset.questionId

    const answerDisplay = document.querySelectorAll(`#${questionType}-answer-${questionId}`)
    const attributeName = questionType.includes('custom') ? `${questionType.replace('-custom', '')}_questions_custom_answers` : `${questionType}_questions_answers`
    const answerInput = document.querySelector(`[name="daily_action[actionable_attributes][${attributeName}][${questionId}]"]`)
    const answer = answerInput.value.trim()

    const formData = new FormData()
    formData.append(answerInput.name, answer)
    formData.append('authenticity_token', document.querySelector('meta[name="csrf-token"]').content)
    formData.append('daily_action[update_from_progress]', true)

    const programId = this.element.dataset.programId
    const url = `/programs/${programId}/daily_action/1/answers`

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        const replacementHtml = answer == '' ? '' : `<div class='mt-1 font-semibold'>Answer:</div>${answer.replace(/\n/g, '<br>')}`

        answerDisplay.forEach(instance => {
          instance.innerHTML = replacementHtml
        })

        this.cancelEdit(event)  
        this.updateProgress()
      } else {
        // Show error message
        console.error(data.errors ? data.errors.join(', ') : 'Failed to save answers')
      }
    })
    .catch(error => {
      console.error('Error saving answers:', error)
      // this.showMessage('An error occurred while saving answers', 'error')
    })
    .finally(() => {
      event.target.disabled = false
      event.target.textContent = 'Save'
    })
  }


  showMessage(message, type) {
    // Create a temporary message element
    const messageEl = document.createElement('div')
    messageEl.className = `fixed top-4 right-4 p-4 rounded-lg z-50 ${
      type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
    }`
    messageEl.textContent = message
    
    document.body.appendChild(messageEl)
    
    // Remove message after 3 seconds
    setTimeout(() => {
      document.body.removeChild(messageEl)
    }, 3000)
  }
} 